
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';

import { getStore } from '../instance';

class DialogContainerBase extends React.Component {

    static create(instance, componentClass) {
        if (!instance) {
            const containerElement = document.createElement('div');
            document.body.appendChild(containerElement);
            instance = render(React.createElement(componentClass), containerElement);
        }
        return instance;
    }

    constructor(props, state) {
        super(props);
        this.state = {
            open: false,
            ...state
        };
    }

    getDialogProps() {
        return {
            open: this.state.open,
            onDismiss: this.handleDismiss
        }
    }

    getResolve() {
        return null;
    }

    handleDismiss = (result) => {
        this.setState({open: false});
        this.getResolve()(result);
    }

    renderContent() {
        return null;
    }

    render() {
        return (
            <Provider store={getStore()}>
                {this.renderContent()}
            </Provider>
        );
    }

    open(props) {
        this.setState({
            open: true,
            ...props
        });
        return new Promise((res) => {
            this.setResolve(res);
        });
    }

    setResolve(res) {
        // nop;
    }
}

export default DialogContainerBase;
